import { render } from "./VerwaltungView.vue?vue&type=template&id=08414cec&scoped=true"
import script from "./VerwaltungView.vue?vue&type=script&lang=js"
export * from "./VerwaltungView.vue?vue&type=script&lang=js"

import "./VerwaltungView.vue?vue&type=style&index=0&id=08414cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08414cec"]])

export default __exports__